
import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const CorporateAccountRequestStatus = {
	name: NAME,
	apiProvider,
	router,
};
